import { render, staticRenderFns } from "./ErrorOverlay.vue?vue&type=template&id=11cbf158"
import script from "./ErrorOverlay.vue?vue&type=script&lang=js"
export * from "./ErrorOverlay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11cbf158')) {
      api.createRecord('11cbf158', component.options)
    } else {
      api.reload('11cbf158', component.options)
    }
    module.hot.accept("./ErrorOverlay.vue?vue&type=template&id=11cbf158", function () {
      api.rerender('11cbf158', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ErrorOverlay.vue"
export default component.exports